import Cta from './Cta.vue'
export default Cta
